import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
    selector: '[appCtrlTemplate]',
    standalone: false
})
export class AppCtrlTemplateDirective {
  @Input('appCtrlTemplate') name: string;
  constructor(public template: TemplateRef<any>) {}
}
